<div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
    <h4 class="matDialogTitle" mat-dialog-title [textContent]="title"></h4>
    <span class="material-icons mb-1" mat-dialog-close>close</span>
</div>
<mat-dialog-content class="mat-typography matDialogBody">
    <div class="widgetSourceTabs" *ngIf="showSourceSetting">
        <mat-tab-group (selectedIndexChange)="selected.setValue($event); sourceChanged(sourceArrayOptions[$event], selected.value)" [selectedIndex]="selected && selected.value">
            <ng-container>
                <mat-tab *ngFor="let source of sourceArrayOptions; let i = index">
                    <ng-template mat-tab-label>
                        <span [textContent]="source.sourceName"></span>
                    </ng-template>
                    <div class="integrationTabContentContainer">
                        <ng-container *ngIf="selected.value !== undefined && selected.value === i">
                            <ng-container *ngTemplateOutlet="sourceDetails; context: { source: source }"></ng-container>
                        </ng-container>
                    </div>
                </mat-tab>
            </ng-container>
        </mat-tab-group>
    </div>
    <div class="masterFilterSelection" *ngIf="isFromMaster">
        <material-radio-group [radioOptions]="radioOptions" [selectedValue]="selectedOutlookFilter" (selectionChanged)="selectedOutlookFilter = $event" [radioButtonClassList]="['mr-4', 'searchType']" [radioGroupClassList]="['d-flex', 'align-items-center']" [ariaLabelledBy]="'filter-selection'" [name]="'masterSearchGroup'"></material-radio-group>
    </div>
    <ng-container *ngIf="selectedOutlookFilter === 'validationStatus'">
        <div class="d-flex align-items-center">
            <label class="mr-3">
                <span [textContent]="translateMsg('Validation Status')"></span>
            </label>
            <mat-form-field class="col-4" appRemoveAriaOwns>
                <mat-select [(value)]="validationFilter" [placeholder]="translateMsg('Select Status')">
                    <mat-option *ngFor="let filter of validationFilters" [value]="filter.name">
                        <span [textContent]="filter.displayName"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedOutlookFilter === 'searchFilters'">
        <div class="d-flex align-items-center">
            <label class="mr-3">
                <span [textContent]="translateMsg('Search Filters')"></span>
            </label>
            <mat-form-field class="col-4" appRemoveAriaOwns>
                <mat-select panelClass="searchFilterDropdown" [(ngModel)]="defaultFilter" [placeholder]="translateMsg('Search Filter')" #matFilterSelect>
                    <ng-container *ngFor="let filter of searchFilters; let i = index">
                        <div class="searchFilterOption">
                            <mat-option [value]="filter" selected="filter.id === defaultFilter.id" [title]="filter.filterName">
                                <span [textContent]="filter.filterName"></span>
                            </mat-option>
                            <mat-icon class="editFilter" [title]="translateMsg('Edit Filter')" (click)="editFilter(filter)">save_as</mat-icon>
                            <mat-icon [title]="translateMsg('Delete')" (click)="deleteSearchFilter(filter)">delete</mat-icon>
                        </div>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedOutlookFilter === 'customSearch'">
        <ng-container *ngIf="isFieldsAvailable; else noFields">
            <ng-container *ngTemplateOutlet="customSearch"></ng-container>
        </ng-container>
    </ng-container>

    <div class="row qbSection sourceQbSection" *ngIf="!initiateElasticSearch">
        <div class="col-12">
            <span class="col-2">
                <span [textContent]="translateMsg('Source')"></span>
            </span>
            <span class="col-4 displyInlineBlock">
                <mat-form-field appRemoveAriaOwns>
                    <mat-select [(ngModel)]="selectedSource" (selectionChange)="webServiceSourceChanged($event)">
                        <mat-option [value]="source.sourceName" *ngFor="let source of webServicesSourceSettings">
                            <span [textContent]="source.sourceName"></span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
        </div>
        <div class="col-6">
            <span class="col-4">
                <span [textContent]="translateMsg('Url')"></span>
            </span>
            <span class="col-8 displyInlineBlock">
                <mat-form-field>
                    <input matInput [(ngModel)]="selectedSource.integrationSettings.url" [disabled]="true" [title]="selectedSource.integrationSettings.url" />
                </mat-form-field>
            </span>
        </div>
        <div class="col-6">
            <span class="col-4">
                <span [textContent]="translateMsg('Method')"></span>
            </span>
            <span class="col-8 displyInlineBlock">
                <mat-form-field>
                    <input matInput [(ngModel)]="selectedSource.integrationSettings.method" [disabled]="true" [title]="selectedSource.integrationSettings.method" />
                </mat-form-field>
            </span>
        </div>
    </div>

    <ng-container *ngIf="initiateElasticSearch && !isReferedCriteria && !isFromMaster">
        <ng-container *ngTemplateOutlet="customSearch"></ng-container>
    </ng-container>
    <ng-container *ngIf="!initiateElasticSearch && !isReferedCriteria">
        <div class="sortQbSection" *ngIf="showSortCriteria">
            <h4>
                <span [textContent]="translateMsg('Search Criteria')"></span>
            </h4>
            <div class="row">
                <mat-tab-group class="paddingRightLeft15">
                    <mat-tab label="Authentication">
                        <div class="col-12 displayInlineFlex">
                            <div class="col-4 displyInlineBlock borderRightForAuthentication centerTheChildDiv">
                                <div class="col-4 displyInlineBlock">
                                    <span [textContent]="translateMsg('Type')"></span>
                                </div>
                                <div class="col-8 displyInlineBlock">
                                    <mat-form-field appRemoveAriaOwns>
                                        <mat-select [(ngModel)]="selectedAuth">
                                            <mat-option [value]="auth.value" *ngFor="let auth of authTypes"><span [textContent]="auth.name"></span></mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-8 displyInlineBlock centerTheChildDiv">
                                <div class="authContent textAlignCenter colorGray" *ngIf="selectedAuth === 'NoAuthSettings'">
                                    <span [textContent]="translateMsg('This request does not use any authorization')"></span>
                                </div>
                                <div class="authContent width100" *ngIf="selectedAuth === 'BasicAuthSettings'">
                                    <div class="loginDetailSection displayInlineFlex">
                                        <div class="col-6">
                                            <material-input [autofocus]="false" [placeholder]="translateMsg('User ID')" [model]="login.userId" (modelChange)="login.userId = $event" [name]="'userId'" [id]="'userId'" [required]="true"></material-input>
                                        </div>
                                        <div class="col-6">
                                            <material-input-password [autofocus]="false" [placeholder]="translateMsg('Password')" [model]="login.password" (modelChange)="login.password = $event" [name]="'userPassword'" [id]="'userPassword'" [required]="true"></material-input-password>
                                        </div>
                                    </div>
                                </div>
                                <div class="authContent width100" *ngIf="selectedAuth === 'OAuthSettings'">
                                    <div class="auth2Section">
                                        <div class="col-12">
                                            <div class="width100 displayInlineFlex">
                                                <div class="col-6">
                                                    <mat-form-field appRemoveAriaOwns>
                                                        <mat-select [(ngModel)]="selectedNewToken" placeholder="translateMsg('Available Tokens')">
                                                            <mat-option [value]="'defaultToken'">
                                                                <span [textContent]="translateMsg('Select Token')"></span>
                                                            </mat-option>
                                                            <mat-option [value]="token.value" *ngFor="let token of newTokens">
                                                                <span [textContent]="token.name"></span>
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div *ngIf="(selectedNewToken !== '' && selectedNewToken !== 'defaultToken') && updateNewTokens()">
                                                <ng-container *ngTemplateOutlet="selectedNewTokenTokenRef"></ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab [label]="translateMsg('Head')">
                        <ng-container *ngIf="isHeadersPresent()">
                            <ng-container *ngFor="let header of selectedSourceHeaders">
                                <div class="col-2 displyInlineBlock">
                                    <div>
                                        <span [textContent]="header.key"></span>
                                    </div>
                                </div>
                                <div class="col-10 displyInlineBlock">
                                    <div class="col-4">
                                        <mat-form-field>
                                            <input matInput [(ngModel)]="header.values" [disabled]="!header.dynamic" (ngModelChange)="updateValue(header)" />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </mat-tab>
                    <mat-tab [label]="translateMsg('Body')">
                        <div class="col-12 displayInlineFlex">
                            <div class="col-4 centerTheChildDiv">
                                <mat-form-field appRemoveAriaOwns>
                                    <mat-select [(ngModel)]="selectedBodyType" placeholder="translateMsg('Type')">
                                        <mat-option [value]="'defaultType'">
                                            <span [textContent]="translateMsg('Select Type')"></span>
                                        </mat-option>
                                        <mat-option [value]="type.value" *ngFor="let type of availableTypes">
                                            <span [textContent]="type.name"></span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-8 centerTheChildDiv">
                                <textarea matInput placeholder="translateMsg('Enter Body')" [(ngModel)]="bodyContent"></textarea>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab [label]="translateMsg('Param')">
                        <ng-container *ngIf="isQueryPresent()">
                            <ng-container *ngFor="let params of selectedSourceParams">
                                <div class="col-2 displyInlineBlock">
                                    <div>
                                        <span [textContent]="params.key"></span>
                                    </div>
                                </div>
                                <div class="col-10 displyInlineBlock">
                                    <div class="col-4">
                                        <mat-form-field>
                                            <input matInput [(ngModel)]="params.values" [disabled]="!params.dynamic" (ngModelChange)="updateValue(params)" />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isReferedCriteria">
        <div class="referredEntityDiv">
            <span class="referredEntityHeader">
                <span [textContent]="translateMsg('Referred Entity Name')"></span>
            </span>
            <span class="referredEntitySpan" [textContent]="ReferredCriteriaEntity && ReferredCriteriaEntity.referredCriteriaName"></span>
        </div>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="center" class="matDialogFooter noBorder">
    <material-button *ngIf="!widgetSettingsModal" class="inline-block mr-3" [text]="translateMsg('Clear Filter')" (buttonClicked)="clearMasterSearch()"></material-button>
    <material-button *ngIf="widgetSettingsModal" class="inline-block mr-3" [text]="translateMsg('Cancel')" color="default" (buttonClicked)="closeModal()"></material-button>
    <material-button *ngIf="!widgetSettingsModal && isFieldsAvailable && selectedOutlookFilter === 'customSearch'" class="inline-block mr-3" color="primary" [text]="translateMsg('Search')" (buttonClicked)="searchMasterEntities()"></material-button>
    <material-button *ngIf="!widgetSettingsModal && isFieldsAvailable && selectedOutlookFilter === 'customSearch'" class="inline-block mr-3" color="primary" [text]="selectedSource?.searchQuery && defaultFilter?.filterName ? translateMsg('Update Filter') : translateMsg('Save Filter')" (buttonClicked)="renderSaveFilterPopup()"></material-button>
    <material-button *ngIf="!widgetSettingsModal && selectedOutlookFilter !== 'customSearch'" class="inline-block mr-3" [color]="'primary'" [text]="translateMsg('Apply Filter')" (buttonClicked)="applySelectedFilter()"></material-button>
    <material-button *ngIf="widgetSettingsModal" [color]="'primary'" class="inline-block" [text]="translateMsg('Save')" [disabled]="!searchQueryFound || isReferedCriteria" (buttonClicked)="saveWidgetSettings()"></material-button>
</mat-dialog-actions>

<ng-template #sourceDetails let-source="source">
    <div class="row qbSection sourceQbSection">
        <div class="col-6">
            <span class="col-4">
                <span [textContent]="translateMsg('Entity')"></span>
            </span>
            <span class="col-8 displyInlineBlock">
                <mat-form-field appRemoveAriaOwns>
                    <mat-select [(value)]="source.selectedEntity" (selectionChange)="entityChanged($event)">
                        <mat-option [value]="'defaultEntity'">
                            <span [textContent]="translateMsg('Select entity')"></span>
                        </mat-option>
                        <mat-option [value]="entity.key" *ngFor="let entity of entityArrayOptions">
                            <span [textContent]="entity.name"></span>
                            <span [textContent]="entity.key"></span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
        </div>
    </div>
</ng-template>

<ng-template #passwordCredential>
    <div>
        <ng-container *ngFor="let auth of passwordCredentialData">
            <div class="col-4 displyInlineBlock">
                <div>
                    <span [textContent]="auth.name"></span>
                </div>
            </div>
            <div class="col-8 displyInlineBlock">
                <ng-container *ngIf="!auth.selectBox">
                    <ng-container *ngIf="auth.name !== 'Password'">
                        <mat-form-field>
                            <input matInput [(ngModel)]="auth.value" [placeholder]="translateMsg('Enter') + auth.name" />
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="auth.name === 'Password'">
                        <mat-form-field>
                            <input matInput [(ngModel)]="auth.value" [placeholder]="translateMsg('Enter') + auth.name" [type]="dataType" />
                            <material-button [hidden]="dataType === 'text'" matSuffix buttonType="icon" size="medium" [titleText]="translateMsg('show')" prefixIconType="image" prefixImgSrc="/assets/images/hide.png" [prefixImgAlt]="translateMsg('hide')" (buttonClicked)="dataType = 'text'" *ngIf="auth.value"></material-button>
                            <material-button [hidden]="dataType === 'password'" matSuffix buttonType="icon" size="medium" [titleText]="translateMsg('hide')" prefixIconType="image" prefixImgSrc="/assets/images/view.png" [prefixImgAlt]="translateMsg('show')" (buttonClicked)="dataType = 'password'" *ngIf="auth.value"></material-button>
                        </mat-form-field>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="auth.selectBox">
                    <mat-form-field appRemoveAriaOwns>
                        <mat-select [(ngModel)]="auth.value" [placeholder]="translateMsg('Client Authentication')" (modelChange)="valueChanged($event, auth)">
                            <mat-option [value]="'defaultClientAuth'">
                                <span [textContent]="translateMsg('Select Client Authentication')"></span>
                            </mat-option>
                            <mat-option [value]="clientAuth.value" *ngFor="let clientAuth of auth.values">
                                <span [textContent]="clientAuth.name"></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #authorizationCode>
    <div>
        <ng-container *ngFor="let auth of authorizationCodeData">
            <div class="col-4 displyInlineBlock">
                <div>
                    <span [textContent]="auth.name"></span>
                </div>
            </div>
            <div class="col-8 displyInlineBlock">
                <ng-container *ngIf="!auth.values">
                    <mat-form-field>
                        <input matInput [(ngModel)]="auth.value" [placeholder]="translateMsg('Enter') + auth.name" />
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="auth.values">
                    <mat-form-field appRemoveAriaOwns>
                        <mat-select [(ngModel)]="selectedAuthClientAuth" [placeholder]="translateMsg('Client Authentication')">
                            <mat-option [value]="'defaultClientAuth'">
                                <span [textContent]="translateMsg('Select Client Authentication')"></span>
                            </mat-option>
                            <mat-option [value]="clientAuth.value" *ngFor="let clientAuth of auth.values">
                                <span [textContent]="clientAuth.name"></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #implicit>
    <div>
        <ng-container *ngFor="let auth of implicitData">
            <div class="col-4 displyInlineBlock">
                <div>
                    <span [textContent]="auth.name"></span>
                </div>
            </div>
            <div class="col-8 displyInlineBlock">
                <ng-container *ngIf="!auth.values">
                    <mat-form-field>
                        <input matInput [(ngModel)]="auth.value" [placeholder]="translateMsg('Enter') + auth.name" />
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="auth.values">
                    <mat-form-field appRemoveAriaOwns>
                        <mat-select [(ngModel)]="selectedImplicitClientAuth" [placeholder]="translateMsg('Client Authentication')">
                            <mat-option [value]="'defaultClientAuth'">
                                <span [textContent]="translateMsg('Select Client Authentication')"></span>
                            </mat-option>
                            <mat-option [value]="clientAuth.value" *ngFor="let clientAuth of auth.values">
                                <span [textContent]="clientAuth.name"></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #clientCredential>
    <div>
        <ng-container *ngFor="let auth of clientCredentialData">
            <div class="col-4 displyInlineBlock">
                <div>
                    <span [textContent]="auth.name"></span>
                </div>
            </div>
            <div class="col-8 displyInlineBlock">
                <ng-container *ngIf="!auth.values">
                    <mat-form-field>
                        <input matInput [(ngModel)]="auth.value" [placeholder]="translateMsg('Enter') + auth.name" />
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="auth.values">
                    <mat-form-field appRemoveAriaOwns>
                        <mat-select [(ngModel)]="selectedClientCredentialClientAuth" [placeholder]="translateMsg('Client Authentication')">
                            <mat-option [value]="'defaultClientAuth'">
                                <span [textContent]="translateMsg('Select Client Authentication')"></span>
                            </mat-option>
                            <mat-option [value]="clientAuth.value" *ngFor="let clientAuth of auth.values">
                                <span [textContent]="clientAuth.name"></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #customSearch>
    <div class="qbSection">
        <h4>
            <span [textContent]="translateMsg('Search Criteria')"></span>
        </h4>
        <ng-container *ngIf="searchQueryFound">
            <app-lib-querybuilder [query]="selectedSource?.searchQuery" [isAddRuleVisible]="true" [config]="searchConfig" [allowRuleset]="allowRuleset" [allowCollapse]="allowCollapse" (queryChanged)="onSearchQueryChanged($event)"></app-lib-querybuilder>
        </ng-container>
        <div *ngIf="loadingSearchCriteria" class="loader">
            <img src="/assets/images/loader.svg" [alt]="translateMsg('Loading...')" />
        </div>
        <div class="textAlignCenter" *ngIf="!searchQueryFound">
            <span [textContent]="translateMsg('No search criteria found')"></span>
        </div>
    </div>
    <div class="qbSection sortQbSection" *ngIf="canShowSortQuery">
        <h4>
            <span [textContent]="translateMsg('Sort Criteria')"></span>
        </h4>
        <app-lib-querybuilder [query]="sortQuery" [config]="sortConfig" [isAddRuleVisible]="true" [allowRuleset]="false" [allowCollapse]="false" (queryChanged)="onSortQueryChanged($event)"></app-lib-querybuilder>
    </div>
</ng-template>

<ng-template #noFields>
    <div class="centerDiv">
        <div class="noRecords">
            <span [textContent]="translateMsg('There are no searchable fields defined for this master')"></span>
        </div>
    </div>
</ng-template>
